import React, { act, Component, useState } from 'react';
import { withRouter } from 'react-router-dom';
import {
  Row,
  Col,
  Button,
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
  Checkbox
} from 'react-bootstrap';
import './CreateModule.css';
import './CreateCourse.css';
import config from '../../constant/config';
import DatePicker from 'react-date-picker';
import 'react-datepicker/dist/react-datepicker.css';
import loadingAnimation from '../../resources/img/loading_animation.gif';
import infoIcon from '../../resources/img/info-icon.png';

export class CreateCourse extends Component {
  constructor(props) {
    super(props);
    let fromCourseTab = false;
    if (props.location && props.location.state && props.location.state.fromCourseTab) {
      fromCourseTab = true;
    }
    const initialSections = [
      {
        id: 1,
        name: 'Section 1',
        selectedModules: []
      }
    ];

    this.state = {
      fromCourseTab: fromCourseTab,
      outcomes: [{ id: 1, value: '' }], // Initial state with one outcome
      selectedModules: [], // Array to store selected modules\
      modules: this.props.modules,
      sections: initialSections,
      expandedSections: [1],
      selectedActivity: '',
      activities: [],
      activitiesSelected: [],
      activityOptions: [
        {
          id: 1,
          description: 'A'
        },
        {
          id: 2,
          description: 'B'
        }
      ],
      selectedTarget: '',
      targetGroups: [],
      targetGroupsSelected: [],
      targetGroupOptions: [
        {
          id: 1,
          description: 'TA'
        },
        {
          id: 2,
          description: 'TB'
        }
      ],
      groups: [],
      selectedDate: new Date(),
      selectedGroupId: null,
      savedGroups: [],
      validTitle: true,
      validDescription: true,
      validImage: true,
      title: '',
      description: '',
      validLearningOutcome: true,
      validSection: true,
      isGroupSelected: false,
      deadlineEnabled: false,
      showMessageBox1: true,
      showMessageBox2: true,
      isDraft: false,
      validGroups: true,
      sectionCounter: initialSections.length,
    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  async componentDidMount() {
    let groups = [];
    const resGroups = await fetch(
      `${config.apiURL}/hub/${this.props.hubId}/getAllGroups`,
      { 
        method: 'GET',
        credentials: 'include',
        headers: { 'content-type': 'application/json' }
      }
    );
    if (resGroups.status == 200) {
      groups = await resGroups.json();
    }

    this.setState({
      groups: groups
    });
  }

  componentWillReceiveProps(props) {
    if(props.modules !== this.state.modules){
      this.setState({modules: props.modules})
    }
    if (props.course) {
     let section_out = props.course.sections.map((section) => ({
          id: section.id,
          name: section.title,
          selectedModules: section.modules.map((module) =>
            props.modules.find((mod) => mod.id === module.moduleId)
          ).filter(Boolean)
      }));
      console.log(section_out);
      const { title, description, learningOutcomes, logoId, sections, groups } =
        props.course;
      this.setState({
        title,
        description,
        outcomes: learningOutcomes.map((outcome, index) => ({
          id: index + 1,
          value: outcome
        })),
        featuredImage1: logoId ? `${config.apiURL}/asset/${logoId}` : null,
         featuredImage: logoId,
        sections: sections.map((section) => ({
          id: section.id,
          name: section.title,
          selectedModules: section.modules.map((module) =>
            props.modules.find((mod) => mod.id === module.moduleId)
          ).filter(Boolean)

        })),
        sectionCounter: sections.length,
        
    })
  }
}
  
  openModal() {
    this.setState({ showModal: true });
  }
  closeModal() {
    this.setState({
      showModal: false
    });
  }

  async onPublishClick() {
    this.setState({
      published: true,
      errorMessage: ''
    });
    let validGroups = true;
    if( this.state.isDraft && this.state.savedGroups.length !== 0)
      validGroups = false;
    const validTitle =
      this.state.title.length > 0 && this.state.title.length < 255;
    const validDescription =
      this.state.description.length > 0 && this.state.description.length < 255;
    const validImage = !!this.state.featuredImage;
    const validLearningOutcome =
      this.state.outcomes.map((outcome) => outcome.value).join('*#*#*').length >
      0;
    const validSection = this.state.sections[0].selectedModules.length > 0;
    
    this.setState({
      validTitle,
      validDescription,
      validImage,
      validLearningOutcome,
      validSection,
      validGroups
    });
 
      
    if (
      !(
        validTitle &&
        validDescription &&
        validImage &&
        validLearningOutcome &&
        validSection &&
        validGroups
      )
    ) {
      this.setState({
        errorMessage:
          'One or more fields are invalid. The invalid fields are highlighted in red.'
      });
      this.setState({ published: false });
      return;
    }
    this.openModal();

    let logoId = this.state.featuredImage;
    if (typeof this.state.featuredImage !== 'string') {
      const payload = new Buffer(this.state.featuredImage, 'binary').toString(
        'binary'
      );
      const featuredImageResponse = await fetch(`${config.apiURL}/asset/`, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({
          title: this.state.featuredImageTitle,
          data: payload,
          fileType: this.state.featuredImageFileType,
          isCourse: true
        })
      });
      logoId = await featuredImageResponse.text();
    }
    const hubId = this.props.hubId;
    const res = await fetch(`${config.apiURL}/hub/${hubId}/course/`, {
      credentials: 'include',
      method: this.state.fromCourseTab ? 'PUT' : 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({
        id: this.state.fromCourseTab ? this.props.course ? this.props.course.id : null : null,
        title: this.state.title,
        description: this.state.description,
        learningOutcomes: this.state.outcomes
          .map((outcome) => outcome.value)
          .join('*#*#*'),
        logoId,
        user: this.props.user,
        sections: this.state.sections,
        groups: this.state.savedGroups,
        isDraft: this.state.isDraft
        
      })
    });
    if (res.status === 200) {
      const body = await res.json();
      this.setState({ published: false, showModal: false });
      if(this.props.edit && this.state.isDraft){
        this.props.history.push(`/${this.props.course.pathName}`,{activeTab: 4});
      }
      else if(!this.props.edit && this.state.isDraft){
        await this.props.getCourseDetails();
          this.props.changeTab(4);
          window.scrollTo({
            top: window.innerHeight / 2, 
            behavior: 'smooth'
          });
          this.props.onClickBack();
      }
      else{
      this.props.history.push(`/course/${body.id}`);
      window.location.assign(`/course/${body.id}`);
      }
    } else {
    
    }
    this.setState({ published: false });
  }

  // Add new learning outcome
  addOutcome = () => {
    this.setState((prevState) => ({
      outcomes: [
        ...prevState.outcomes,
        { id: prevState.outcomes.length + 1, value: '' } // Add new outcome with incremented id
      ]
    }));
  };

  // Handle learning outcome input change
  handleOutcomeChange = (index, event) => {
    const newOutcomes = [...this.state.outcomes];
    newOutcomes[index].value = event.target.value;
    this.setState({ outcomes: newOutcomes });
  };

  // Add new section
  addSection = () => {
    this.setState((prevState) => {
      // Get the id of the last section, if sections array is not empty
      const lastSectionId =
        prevState.sections.length > 0
          ? prevState.sections[prevState.sections.length - 1].id
          : 0; 

      return {
        sections: [
          ...prevState.sections,
          {
            id: lastSectionId + 1,
            selectedModules: [],
            name: `Section ${prevState.sectionCounter + 1}`
          } // Add new section with incremented id
        ],
        expandedSections: [
          ...prevState.expandedSections,
          lastSectionId + 1 // Sync expandedSections with the new section id
        ],
        sectionCounter: prevState.sectionCounter + 1 // Increment section counter
      };
    });
  };

  handleSelect = (sectionId, e) => {
    const moduleId = parseInt(e.target.value);
    const selectedModule = this.state.modules.find(
      (mod) => mod.id === moduleId
    );

    if (selectedModule) {
      this.setState((prevState) => ({
        sections: prevState.sections.map((section) => {
          if (section.id === sectionId) {
            // Check if the module already exists in the section
            const alreadySelected = section.selectedModules.some(
              (mod) => mod.id === moduleId
            );

            // If it doesn't exist, add it, otherwise return the section as is
            if (!alreadySelected) {
              return {
                ...section,
                selectedModules: [...section.selectedModules, selectedModule]
              };
            }
          }
          return section;
        })
      }));
    }
  };

  // Handle delete of a selected module from a specific section
  handleDeleteModule = (sectionId, moduleId) => {
    this.setState((prevState) => ({
      sections: prevState.sections.map((section) =>
        section.id === sectionId
          ? {
              ...section,
              selectedModules: section.selectedModules.filter(
                (mod) => mod.id !== moduleId
              )
            }
          : section
      )
    }));
  };

  handleToggleCollapse = (sectionId) => {
    this.setState((prevState) => {
      const expandedSections = [...prevState.expandedSections];
      const sectionIndex = expandedSections.indexOf(sectionId);

      if (sectionIndex > -1) {
        // If section is already expanded, remove it
        expandedSections.splice(sectionIndex, 1);
      } else {
        // Otherwise, add the sectionId to the array
        expandedSections.push(sectionId);
      }
      return { expandedSections };
    });
  };

  handleDeleteSection = (sectionId) => {
    this.setState((prevState) => {
      const newSections = prevState.sections.filter(
        (section) => section.id !== sectionId
      );
      const newExpanded = prevState.expandedSections.filter((id) => id !== sectionId);
      return {
        sections: newSections,
        expandedSections: newExpanded,
      };
    });
  };

  handleSectionNameChange = (sectionId, event) => {
    const newName = event.target.value; // Get the new name from the input field
    this.setState((prevState) => ({
      sections: prevState.sections.map((section) =>
        section.id === sectionId
          ? { ...section, name: newName } // Update the name of the section with the given id
          : section
      )
    }));
  };

  handleDeleteOutcome = (index) => {
    this.setState((prevState) => ({
      outcomes: prevState.outcomes.filter((_, i) => i !== index)
    }));
  };

  onChangeFile(e) {
    e.preventDefault();
    const selectedFiles = this.profileAvatarFileInput.files;
    this.setState({
      featuredImage1: URL.createObjectURL(e.target.files[0])
    });
    this.readFile(selectedFiles[0]);
  }
  readFile(file) {
    const reader = new FileReader();
    const acceptedList = [
      'image/PNG',
      'image/png',
      'image/jpeg',
      'image/jpg',
      'image/JPEG'
    ];
    reader.onloadend = () => {
      if (file.size > 5000000) {
        this.setState({
          featuredImage: null,
          featuredImageHelpText: 'Files must be less than 5mb',
          featuredImageFileType: '',
          featuredImageTitle: '',
          validImage: false
        });
        return;
      }
      if (!acceptedList.includes(file.type)) {
        this.setState({
          featuredImage: null,
          featuredImageHelpText: 'Images must be jpeg or png',
          featuredImageFileType: '',
          featuredImageTitle: '',
          validImage: false
        });
        return;
      }
      this.setState({
        featuredImage: reader.result,
        featuredImageFileType: file.type,
        featuredImageHelpText: '',
        featuredImageTitle: file.name,
        validImage: true
      });
    };
    if (file) {
      reader.readAsArrayBuffer(file);
    }
  }

  saveGroup() {
    const chosenGroup = this.state.groups.find(
      (group) => group.id === Number(this.state.selectedGroupId)
    );

    this.setState((prevState) => ({
      savedGroups: [
        ...prevState.savedGroups, // Spread the existing savedGroups array
        {
          id: prevState.selectedGroupId, // Add new group details
          name: chosenGroup.name,
          deadline: !prevState.deadlineEnabled
            ? prevState.selectedDate.toLocaleDateString()
            : new Date(
                new Date().setFullYear(new Date().getFullYear() + 5)
              ).toLocaleDateString()
        }
      ]
    }));

    this.setState({ deadlineEnabled: false });
  }

  handleDeleteGroup(groupId) {
    this.setState((prevState) => ({
      savedGroups: prevState.savedGroups.filter(
        (group) => Number(group.id) !== Number(groupId)
      )
    }));
  }

    async onDeleteDraftCourse() {
      if(this.state.fromCourseTab){
      const hubId = this.props.course.hubId;
      const courseId = this.props.course.id;
      try {
        const res = await fetch(
          `${config.apiURL}/hub/${hubId}/course/${courseId}`,
          {
            credentials: 'include',
            method: 'DELETE',
            headers: { 'content-type': 'application/json' }
          }
        );
        if (res.status === 200) {
          this.props.history.push('/' + this.props.course.pathName,{activeTab: 4});
        }
      } catch (err) {
        console.error(err);
      }}
      else{
         this.props.history.push('/course/' + this.props.course.id);
      }
    }

  render() {
    return (
      <div className="create-module-tab-container">
        <div className="padding">
           {this.state.showMessageBox1 && <div className="message-box" style={{display:'flex'}}>
            <div>You can’t modify the course structure after publishing — this includes adding, deleting, or reordering sections and modules. However, you can still update the content inside existing modules or quizzes at any time, and those changes will automatically reflect in the published course.</div>
            <Button style={{backgroundColor:'lightyellow', outline:'none'}} onClick={()=>{this.setState({showMessageBox1: false})}}> X </Button></div>}
          <div className="form-heading-container">
              <h1 className="form-heading">
                {this.props.edit ? 'Edit Course' : 'Create a New Course'}
              </h1>
            {!this.props.edit && <div className="back-button-container">
              <Button
                className="back-button"
                onClick={() => {
                  this.props.onClickBack();
                }}
              >
                Back
              </Button>
            </div>}
          </div>
          <div className="form-container">
            <FormGroup className="form" controlId="title">
              <ControlLabel>
                Course Title:<span className="required-asterisk">*</span>
              </ControlLabel>
              <div style={{ flex: '1 1' }}>
                <FormControl
                  autoFocus
                  className="form-input"
                  type="text"
                  value={this.state.title}
                  onChange={(e) => this.setState({ title: e.target.value })}
                />
                {!this.state.validTitle && (
                  <HelpBlock>Must Enter Course Title</HelpBlock>
                )}
              </div>
            </FormGroup>
            <FormGroup className="form" controlId="description">
              <ControlLabel>
                Course Description:<span className="required-asterisk">*</span>
              </ControlLabel>
              <div style={{ flex: '1 1' }}>
                <FormControl
                  className="form-input"
                  type="text"
                  value={this.state.description}
                  onChange={(e) =>
                    this.setState({ description: e.target.value })
                  }
                />
                {!this.state.validDescription && (
                  <HelpBlock>Must Enter Course Purpose</HelpBlock>
                )}
              </div>
            </FormGroup>

            <div>
              {this.state.outcomes.map((outcome, index) => (
                <FormGroup
                  className="form"
                  controlId={`learningOutcome-${outcome.id}`}
                  key={outcome.id}
                >
                  <ControlLabel>
                    Learning Outcome {outcome.id}:
                    <span className="required-asterisk">*</span>
                  </ControlLabel>
                  <div
                    style={{
                      flex: '1 1',
                      paddingLeft: index == 0 ? '0' : '2.4%'
                    }}
                  >
                    <FormControl
                      className="form-input"
                      type="text"
                      value={outcome.value}
                      onChange={(e) => this.handleOutcomeChange(index, e)}
                    />
                    {!this.state.validLearningOutcome && (
                      <HelpBlock>
                        {'At least one learning outcome is required'}
                      </HelpBlock>
                    )}
                  </div>
                  {index !== 0 && (
                    <button
                      type="button"
                      style={{
                        backgroundColor: 'transparent',
                        border: 'none',
                        color: 'red',
                        fontSize: '20px',
                        marginLeft: '10px',
                        cursor: 'pointer'
                      }}
                      onClick={() => this.handleDeleteOutcome(index)}
                    >
                      &#x2716;{' '}
                      {/* Unicode character for the cross (X) symbol */}
                    </button>
                  )}
                </FormGroup>
              ))}
              <Button className="blue-button" onClick={this.addOutcome}>
                Add New Outcome
              </Button>
            </div>

            <FormGroup
              className="form"
              controlId="form"
              style={{ width: '100%', paddingTop: '20px' }}
            >
              <div style={{ display: 'block', flex: '1' }}>
                <ControlLabel className="featured-title">
                  Thumbnail Image:<span className="required-asterisk">*</span>
                </ControlLabel>
                <HelpBlock>Recommended Size 180 x 100</HelpBlock>
                {!this.state.validImage && (
                  <HelpBlock>
                    {this.state.featuredImageHelpText ||
                      'Course Thumbnail is required'}
                  </HelpBlock>
                )}
              </div>
              <div className="form-button-container-featureImage">
                <img
                  className="img1"
                  alt="featured"
                  src={this.state.featuredImage1}
                />
                <Button
                  className="attach-button-featureImage button"
                  onClick={() => this.profileAvatarFileInput.click()}
                >
                  Upload
                </Button>
              </div>
            </FormGroup>
            {/* Module or Quiz selection */}
            <div className="course-section-container">
              <div style={{ display: 'flex' }}>
                <ControlLabel style={{ display: 'flex', flex: '0' }}>
                  Sections:{' '}
                </ControlLabel>
                <div className="info-container">
                  <img
                    className="info-icon"
                    src={infoIcon}
                    alt="help icon"
                    style={{ height: '18px', width: '18px' }}
                  />
                  <span
                    className="hover-text"
                    style={{ top: '-5px', left: '0px' }}
                  >
                    Create a section for your eLearning Course. A section
                    typically has one or more Information Modules followed by a
                    Quiz Module to then test a user's knowledge and learning on
                    the content in the Information Modules that came before it.
                  </span>
                </div>
              </div>
            </div>
            {/* Sections for Module/Quiz */}
            <div>
              {this.state.sections.map((section, index) => (
                <div key={section.id} style={{ marginBottom: '20px' }}>
                  <div>
                    <input
                      type="text"
                      className="section-label"
                      defaultValue={section.name }
                      onChange={(e) =>
                        this.handleSectionNameChange(section.id, e)
                      } // Editable name input
                    />
                    <button
                      className="arrow-button"
                      onClick={() => this.handleToggleCollapse(section.id)}
                    >
                      {this.state.expandedSections.includes(section.id)
                        ? '\u25BC'
                        : '\u25B6'}
                    </button>

                    {index !== 0 && (
                      <button
                        className="delete-button"
                        onClick={() => this.handleDeleteSection(section.id)}
                      >
                        Delete Section
                      </button>
                    )}
                  </div>
                  {/* Conditionally render the collapsible content */}
                  {this.state.expandedSections.includes(section.id) && (
                    <div className="module-selection">
                      <hr></hr>
                      <div
                        style={{ display: 'flex' }}
                        className="course-section-container"
                      >
                        <ControlLabel
                          style={{ flex: 'revert' }}
                        >
                          Select Information or Quiz module:
                          {index === 0 && (
                            <span className="required-asterisk">*</span>
                          )}{' '}
                        </ControlLabel>
                        <div className="info-container">
                          <img
                            className="info-icon"
                            src={infoIcon}
                            alt="help icon"
                            style={{ height: '18px', width: '18px' }}
                          />
                          <span
                            className="hover-text"
                            style={{ top: '-5px', left: '0px' }}
                          >
                            You can select Information or Quiz Modules that are
                            Public, Private or Course-Only. Hidden Modules will
                            need their Visibility Setting updated to be one of
                            the above to be available to be selected as part of
                            a Section in your Course. To add a Hidden module,
                            please update its visibility settings in Edit
                            Module.
                          </span>
                        </div>
                      </div>
                  {!this.state.validSection && index === 0 && (
                            <HelpBlock>
                              {'At least one module is required'}
                            </HelpBlock>
                          )}
                      {section.selectedModules.map((selectedModule) => (
                        <div
                          key={selectedModule.id}
                          style={{ padding: '10px', marginTop: '10px' }}
                        >
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between'
                            }}
                          >
                            <div className="module-creator-display">
                              <h4 style={{ fontWeight: 'bold' }}>
                                {selectedModule.title}
                              </h4>
                            </div>
                            <div
                              style={{
                                flex: 1,
                                textAlign: 'center',
                                fontWeight: 'bold'
                              }}
                            >
                              <p>
                                Created by {selectedModule.createdBy.firstName}{' '}
                                {selectedModule.createdBy.surname}
                              </p>
                            </div>
                            <button
                              className="delete-button"
                              onClick={() =>
                                this.handleDeleteModule(
                                  section.id,
                                  selectedModule.id
                                )
                              }
                            >
                              Delete
                            </button>
                          </div>
                        </div>
                      ))}
                      <div className="dropdown">
                        <select
                          onChange={(e) => this.handleSelect(section.id, e)}
                        >
                          <option value="">
                            Select Information or Quiz module{' '}
                          </option>
                          {this.state.modules
                            .sort((a, b) => a.categoryId - b.categoryId)
                            .map((module) => (
                              <option
                                key={module.id}
                                value={module.id}
                                disabled={module.accessId == 3}
                              >
                                {module.categoryId === 3 ? 'Quiz: ' : module.categoryId === 4 ? 'Forum: ' : 'Info: '}
                                {module.title}
                              </option>
                            ))}
                        </select>
                      </div>
                      <hr></hr>
                    </div>
                  )}
                </div>
              ))}

              <Button className="blue-button-center" onClick={this.addSection}>
                Add New Section
              </Button>
            </div>
            <hr style={{ height: '10px' }}></hr>
            <div className="group-selection">
              <div>
                {this.state.savedGroups.map((group) => (
                  <div
                    key={group.id}
                    style={{ padding: '10px', marginTop: '10px' }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between'
                      }}
                    >
                      <div className="module-creator-display">
                        <h4 style={{ fontWeight: 'bold' }}>{group.name}</h4>
                      </div>
                      <div
                        style={{
                          flex: 1,
                          textAlign: 'center',
                          fontWeight: 'bold'
                        }}
                      >
                        {' '}
                        <p>Deadline: {group.deadline}</p>
                      </div>

                      <button
                        className="delete-button"
                        onClick={() => this.handleDeleteGroup(group.id)}
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                ))}
              </div>
              <div className="group-div">
                <div
                  style={{ display: 'flex', flex: '0.7 1' }}
                  className="course-section-container"
                >
                  <ControlLabel style={{ display: 'flex', flex: 'revert' }}>
                    Assign to:{' '}
                  </ControlLabel>
                  <div className="info-container">
                    <img
                      className="info-icon"
                      src={infoIcon}
                      alt="help icon"
                      style={{ height: '18px', width: '18px' }}
                    />
                    <span
                      className="hover-text"
                      style={{ top: '-5px', left: '0px' }}
                    >
                      Assign your eLearning Course to a Group or multiple
                      Groups. If you don't have any available Groups to select,
                      you can create a Group under the Groups tab of your Hub.
                    </span>
                  </div>
                </div>
                <div className="dropdown-group">
                  <select
                    onChange={(e) => {
                      this.setState({
                        selectedGroupId: e.target.value,
                        isGroupSelected: true
                      });
                    }}
                  >
                    <option value={this.state.selectedGroupId}>
                      Select Group{' '}
                    </option>
                    {this.state.groups.map((group) => (
                      <option key={group.id} value={group.id}>
                        {group.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="group-div">
              <ControlLabel>Set Deadline:</ControlLabel>
                  <FormGroup className="form form-group"
                  style={{
    opacity: !this.state.deadlineEnabled ? 1 : 0.3,
    pointerEvents: !this.state.deadlineEnabled ? 'auto' : 'none',
    transition: 'opacity 0.3s ease-in-out',
  }} >
                    <DatePicker
                      value={new Date(this.state.selectedDate)}
                      onChange={(date) => {
                        this.setState({ selectedDate: date });
                      }}
                      clearIcon={null}
                      calendarIcon={<i className="fa fa-calendar fa-2x" />}
                    />
                  </FormGroup>
              </div>
              <div style={{display:'flex',justifyContent:'flex-end',marginRight:'300px'}}>
                <Checkbox className='checkbox' name="commentGroup" onChange={() => this.setState({ deadlineEnabled: !this.state.deadlineEnabled })} checked={this.state.deadlineEnabled}>
                                  No Deadline
                                </Checkbox>
                                <div className="info-container" style={{ marginTop:'5px'}}>
                  <img
                    className="info-icon"
                    src={infoIcon}
                    alt="help icon"
                    style={{ height: '18px', width: '18px' }}
                  />
                  <span
                    className="hover-text"
                    style={{ top: '-5px', left: '0px' }}
                  >
                    If no deadline is selected, a default date five years from today will be automatically applied.
                  </span>
                </div>
              </div>
              <div className="publish-button-container">
                <Button
                  className="publish-button button"
                  disabled={!this.state.isGroupSelected}
                  onClick={() => this.saveGroup()}
                >
                  Save Group
                </Button>
              </div>
              {!this.state.validGroups && <HelpBlock> Please remove assigned groups to save as draft.</HelpBlock>}
            </div>
            <hr></hr>
            {/* <FormGroup className="form" controlId="description" >
              <ControlLabel>Estimated Time:</ControlLabel>
              <div style={{ flex: '1 1' }}>
                <FormControl
                  className="form-input-small"
                  type="text"
                  defaultValue="00:00:00"
                />
                {!this.state.validDescription && <HelpBlock>Must Enter Module Purpose</HelpBlock>}
              </div>
            </FormGroup> */}

            {/* <FormGroup className="form" controlId="description" >
              <ControlLabel>Set Time Limit:</ControlLabel>
              <div style={{ flex: '1 1' }}>
                <FormControl
                  className="form-input-small"
                  type="text"
                  defaultValue="00:00:00"
                />
                {!this.state.validDescription && <HelpBlock>Must Enter Module Purpose</HelpBlock>}
              </div>
            </FormGroup> */}
          </div>

          <div className="publish-feedback">
            {/* {this.state.published && (this.props.edit ? 'Updating Course...' : 'Creating Course...')} */}
          </div>
          {this.state.errorMessage && (
            <span style={{ marginRight: '1em', color: '#a94442' }}>
              {this.state.errorMessage}
            </span>
          )}
          <div className="publish-button-container">
            {this.props.edit &&
              <Button
                className="delete-draft-button button"
                onClick={() => {
                  this.onDeleteDraftCourse();
                }}
              >
                Delete Draft
              </Button>
}
            <Button
              className="save-as-draft-button button"
              onClick={() => {this.setState({ isDraft: true }, () => this.onPublishClick())}}
            >
               Save as Draft
            </Button>
            <Button
              className="publish-button button"
              onClick={() => { this.onPublishClick() }}
            >
               Publish
            </Button>
          </div>
            {this.state.showMessageBox2 && <div className="message-box" style={{display:'flex'}}>
            <div>You can’t modify the course structure after publishing — this includes adding, deleting, or reordering sections and modules. However, you can still update the content inside existing modules or quizzes at any time, and those changes will automatically reflect in the published course.</div>
            <Button style={{backgroundColor:'lightyellow', outline:'none'}} onClick={()=>{this.setState({showMessageBox2: false})}}> X </Button></div>}
          {this.state.showModal && <div className="blur" />}
          {this.state.showModal && (
            <div className="gif-container" backdropOpacity={0.3}>
              <img className="gif" src={loadingAnimation} alt="loading" />
            </div>
          )}

          <div className="publish-feedback">
            {this.state.published &&
              (this.props.edit ? 'Updating draft...' : this.state.isDraft ? 'Creating draft...' : 'Creating course...')}
          </div>
          <div style={{ display: 'none' }}>
            <input
              ref={(f) => {
                this.profileAvatarFileInput = f;
              }}
              className="form-input logo"
              type="file"
              onChange={(e) => this.onChangeFile(e)}
              accept="image/*"
            />

            <input
              ref={(f) => {
                this.moduleImageFileInput = f;
              }}
              className="form-input logo"
              type="file"
              onChange={(e) => this.onChangeImageFiles(e)}
              accept="image/jpeg,image/png,application/pdf,.zip"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(CreateCourse);
